// Security utilities for safe URL handling and input validation

// Allowed domains for external links
export const ALLOWED_DOMAINS = {
  WHATSAPP: ['wa.me'],
  BOOKING: ['www.booking.com', 'booking.com'],
  INSTAGRAM: ['www.instagram.com', 'instagram.com'],
  GOOGLE_MAPS: ['www.google.com', 'maps.google.com']
};

/**
 * Validates if a URL is safe to open
 * @param {string} url - URL to validate
 * @param {string[]} allowedDomains - Array of allowed domains
 * @returns {boolean} - true if URL is safe
 */
const isSecureUrl = (url, allowedDomains = []) => {
  try {
    const urlObj = new URL(url);
    
    if (!['https:', 'tel:', 'mailto:'].includes(urlObj.protocol)) {
      return false;
    }
    
    if (allowedDomains.length > 0) {
      return allowedDomains.includes(urlObj.hostname);
    }
    
    return true;
  } catch {
    return false;
  }
};

/**
 * Opens URL safely with validation and security features
 * @param {string} url - URL to open
 * @param {string[]} allowedDomains - Array of allowed domains
 * @returns {boolean} - true if URL opened successfully
 */
export const openSecureUrl = (url, allowedDomains = []) => {
  if (!isSecureUrl(url, allowedDomains)) {
    return false;
  }
  
  return !!window.open(url, '_blank', 'noopener,noreferrer');
};
